import { swSettings } from "app/common/services/swSettings";
import type { CommonRequestOptions, IRequestOpts, RequestParams } from "app/services/fetchService";
import { DefaultFetchService } from "app/services/fetchService";

const defaultFetchServiceOverride = Object.create(DefaultFetchService.getInstance());

defaultFetchServiceOverride.get = function get<R>(
    url: string,
    params?: object,
    config?: CommonRequestOptions,
): Promise<R> {
    return Object.getPrototypeOf(this).get(url, params, {
        ...config,
        preventAutoCancellation: true,
    });
};

export const rerouteToSalesService = (requestParams: RequestParams): RequestParams => {
    const { swsites } = swSettings;

    const shouldChangeHost = requestParams.url.includes("sales-api") && swsites.pro !== swsites.sales;

    if (!shouldChangeHost) {
        return requestParams;
    }

    const doesStartWithSlash = requestParams.url.startsWith("/");
    const url = `${swsites.sales}${doesStartWithSlash ? "" : "/"}${requestParams.url}`;
    const options: IRequestOpts = { ...requestParams.options, credentials: "include" };
    return { url, options };
};

DefaultFetchService.getInstance().registerRequestInterceptor(rerouteToSalesService);

export default defaultFetchServiceOverride;
